<template>
  <div>
    <div class="header">
      <div class="label header1">剩余加工任务</div>
      <div class="value" id="remainingTasks">12</div>
    </div>

    <div class="header">
      <div style="position: absolute;
      cursor: pointer;
      color: #FFFFFF;
      top: 30px;
      left: 30px;
      z-index: 1;
      height: calc(100vh - 30px);
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;" @click="addPoint()">x: {{ x }}, y:{{ y }}
        <div style="display: flex;justify-content: flex-end;margin-right: 10px;">
          <div id="time"></div>
          秒前更新
        </div>
        <div v-for="(p, i) in pointArr" :key="i" style="margin-right: 10px;">
          <div>x: {{ p.x }}, y:{{ p.y }}</div>
        </div>
      </div>
      <canvas id="coordinateCanvas" width="500" height="500" v-show="pointArr.length > 0"></canvas>
      <div class="label ">当前任务加工时间预估</div>
      <div class="countdown-row">
        <!-- 小时 -->
        <div class="time-unit">
          <svg class="time-circle" viewBox="0 0 100 100">
            <circle class="circle-bg" cx="50" cy="50" r="45"></circle>
            <circle class="circle-progress hours-circle" cx="50" cy="50" r="45" stroke-dasharray="283" stroke-dashoffset="283"></circle>
          </svg>
          <div class="time-text" id="hours">00</div>
          <div class="time-label">时</div>
        </div>

        <!-- 分钟 -->
        <div class="time-unit">
          <svg class="time-circle" viewBox="0 0 100 100">
            <circle class="circle-bg" cx="50" cy="50" r="45"></circle>
            <circle class="circle-progress minutes-circle" cx="50" cy="50" r="45" stroke-dasharray="283" stroke-dashoffset="283"></circle>
          </svg>
          <div class="time-text" id="minutes">00</div>
          <div class="time-label">分</div>
        </div>

        <!-- 秒 -->
        <div class="time-unit">
          <svg class="time-circle" viewBox="0 0 100 100">
            <circle class="circle-bg" cx="50" cy="50" r="45"></circle>
            <circle class="circle-progress seconds-circle" cx="50" cy="50" r="45" stroke-dasharray="283" stroke-dashoffset="283"></circle>
          </svg>
          <div class="time-text" id="seconds">00</div>
          <div class="time-label">秒</div>
        </div>

        <!-- 毫秒 -->
        <div class="time-unit">
          <svg class="time-circle" viewBox="0 0 100 100">
            <circle class="circle-bg" cx="50" cy="50" r="45"></circle>
            <circle class="circle-progress millis-circle" cx="50" cy="50" r="45" stroke-dasharray="283" stroke-dashoffset="283"></circle>
          </svg>
          <div class="time-text" id="millis">000</div>
          <div class="time-label">毫秒</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mySocket from "@/components/mySocket";

export default {
  name: "LaserTask.vue",
  data () {
    return {
      x: 999.999,
      y: 999.999,
      time: new Date().getTime(),
      pointArr: [],
      canvasScale: 1, // 初始缩放比例
      offsetX: 0,     // X 偏移量（居中使用）
      offsetY: 0      // Y 偏移量（居中使用）
    }
  },
  watch: {
    pointArr: {
      deep: true,
      handler () {
        this.drawCoordinates();
      }
    },
    x () {
      this.drawCoordinates();
    },
    y () {
      this.drawCoordinates();
    }
  },
  methods: {
    async copyVBAString () {
      let vbaStr = '';
      for (let i in this.pointArr) {
        // Array(1261.325, 314.216),Array(1277.992, 317.216),Arra
        // POINT 1261.325,314.216
        // POINT 1277.992,317.216
        vbaStr += `POINT ${this.pointArr[i].x},${this.pointArr[i].y}\n`;
      }
      console.log(vbaStr)
      try {
        // 优先使用 Clipboard API（现代浏览器）
        await navigator.clipboard.writeText(vbaStr);
        // alert('复制成功！');
      } catch (err) {
        // 回退到 execCommand（适用于旧版浏览器如部分安卓 Edge）
        const textArea = document.createElement('textarea');
        textArea.value = vbaStr;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
        } catch (execErr) {
          console.error('复制失败:', execErr);
        } finally {
          document.body.removeChild(textArea);
        }
      }
    },
    addPoint () {
      this.pointArr.push({
        x: this.x,
        y: this.y
      })
      this.copyVBAString()
    },
    drawCoordinates () {
      const canvas = document.getElementById('coordinateCanvas');
      const ctx = canvas.getContext('2d');

      const padding = 20; // 边距留白
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      // 获取所有点的 x 和 y 坐标数组
      const xs = this.pointArr.map(p => p.x);
      const ys = this.pointArr.map(p => p.y);
      xs.push(this.x)
      ys.push(this.y)

      if (xs.length === 0 || ys.length === 0) return;

      // 计算最大值和最小值
      const minX = Math.min(...xs);
      const maxX = Math.max(...xs);
      const minY = Math.min(...ys);
      const maxY = Math.max(...ys);

      // 计算缩放比例
      const scaleX = (canvasWidth - 2 * padding) / (maxX - minX);
      const scaleY = (canvasHeight - 2 * padding) / (maxY - minY);
      this.canvasScale = Math.min(scaleX, scaleY, 1); // 防止放大过度

      // 居中偏移量
      this.offsetX = (canvasWidth - (maxX - minX) * this.canvasScale) / 2 - minX * this.canvasScale;
      this.offsetY = (canvasHeight - (maxY - minY) * this.canvasScale) / 2 - minY * this.canvasScale;

      // 清空画布
      ctx.clearRect(0, 0, canvasWidth, canvasHeight);

      // 绘制所有点
      ctx.fillStyle = 'blue';
      for (let i = 0; i < this.pointArr.length; i++) {
        const px = this.pointArr[i].x * this.canvasScale + this.offsetX;
        const py = this.pointArr[i].y * this.canvasScale + this.offsetY;
        ctx.beginPath();
        ctx.arc(px, py, 5, 0, 2 * Math.PI);
        ctx.fill();
      }
      // 绘制当前坐标
      ctx.fillStyle = 'red';
      ctx.beginPath();
      ctx.arc(this.x * this.canvasScale + this.offsetX,
          this.y * this.canvasScale + this.offsetY, 2, 0, 2 * Math.PI);
      ctx.fill();
    },
  },
  mounted () {
    // this.generateRandomPoints(); // 生成 100 个随机点位
    this.drawCoordinates();      // 绘制点位到 canvas 上
    // 模拟数据
    let remainingTasks = 0;
    // 剩余?秒
    // let totalTime = 23 * 3600 + 59 * 60 + 59;
    let remainingTime = 3;
    let lastUpdate = Date.now();
    let animationFrame;

    let self = this;
    this.mySocket = mySocket.create({
      onmessage (msg) {
        console.log('msg', msg)
        let data = msg.type === 3 ? JSON.parse(msg.data) : false
        // {"title":"更新待加工任务","forward":true,"count":14}
        if (data && data.title === "更新待加工任务") {
          remainingTasks = data.count
        }
        // {"title":"更新剩余加工时间","forward":true,"timeMs":1028189.1777777777}
        if (data && data.title === "更新剩余加工时间") {
          remainingTime = Math.round(data.timeMs / 1000)
        }
        // {"title":"更新XY坐标","forward":true,"x":"286.572","y":"883.647"}
        if (data && data.title === "更新XY坐标") {
          self.x = data.x
          self.y = data.y
          self.time = data.time
        }
      }
    })

    // 更新显示
    function updateDisplay () {
      document.getElementById('remainingTasks').textContent = remainingTasks;

      // 计算时分秒毫秒
      const hours = Math.floor(remainingTime / 3600);
      const minutes = Math.floor((remainingTime % 3600) / 60);
      const seconds = Math.floor(remainingTime % 60);
      const now = Date.now();
      const millis = remainingTime <= 0 ? 0 : 999 - (now % 1000);

      document.getElementById('hours').textContent = hours.toString().padStart(2, '0');
      document.getElementById('minutes').textContent = minutes.toString().padStart(2, '0');
      document.getElementById('seconds').textContent = seconds.toString().padStart(2, '0');
      document.getElementById('millis').textContent = millis.toString().padStart(3, '0');

      // 更新圆形进度条
      updateCircle('hours', hours, 24);
      updateCircle('minutes', minutes, 60);
      updateCircle('seconds', seconds, 60);
      updateCircle('millis', millis, 999);
      document.getElementById('time').textContent = (new Date().getTime() - self.time) / 1000
    }

    // 更新圆形进度条
    function updateCircle (unit, value, max) {
      const progress = value / max;
      const circle = document.querySelector(`.${unit}-circle`);
      const circumference = 2 * Math.PI * 45;
      const offset = circumference * (1 - progress);
      circle.style.strokeDashoffset = offset;
    }

    // 倒计时函数
    function countdown () {
      const now = Date.now();
      const delta = now - lastUpdate;

      if (delta >= 1000) {
        lastUpdate = now;
        if (remainingTime > 0) {
          remainingTime--;
        }
      }
      updateDisplay();
      animationFrame = requestAnimationFrame(countdown);
    }

    // 初始化显示
    updateDisplay();

    // 启动动画循环
    animationFrame = requestAnimationFrame(countdown);

    // 窗口大小变化时调整布局
    window.addEventListener('resize', function () {
      cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(countdown);
    });
  }
}
</script>
<style>
#coordinateCanvas {
  border: 1px solid #fff;
  margin-top: 20px;
  background-color: #222;
}

.v-head, #head {
  display: none;
}

body {
  background-color: #000 !important;
  color: #fff;
  font-family: Arial, sans-serif;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 10px;
}
</style>
<style scoped>

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.header {
  width: 100%;
  text-align: center;
  margin-bottom: 10vh;
}

.label {
  font-size: 8vw;
  color: #fff;
  margin-bottom: 4vh;
}

.header1 {
  margin-bottom: 2vh;
}

.value {
  font-size: 15vw;
  font-weight: bold;
  color: #fff;
}

.countdown-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
}

.time-unit {
  position: relative;
  /*width: 22vw;*/
  /*height: 22vw;*/
  /*min-width: 100px;*/
  /*min-height: 100px;*/
  /*max-width: 200px;*/
  /*max-height: 200px;*/
  /*margin: 0 2vw;*/
  width: calc(25% - 10px);
  margin: 0 5px;
}

.time-circle {
  width: 100%;
  height: 100%;
  position: relative;
}

.circle-bg {
  fill: none;
  stroke: #333;
  stroke-width: 8;
}

.circle-progress {
  fill: none;
  stroke-width: 8;
  stroke-linecap: round;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
}

.circle-progress:not(.millis-circle) {
  transition: stroke-dashoffset 1s linear;
}

.hours-circle {
  stroke: #FF5722;
}

.minutes-circle {
  stroke: #4CAF50;
}

.seconds-circle {
  stroke: #2196F3;
}

.millis-circle {
  stroke: #9C27B0;
}

.time-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 8vw;
  font-weight: bold;
  color: #fff;
  width: 100%;
  text-align: center;
}

.time-label {
  position: absolute;
  bottom: 14%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  color: #FFFFFF;
  width: 100%;
  text-align: center;
}

@media (min-width: 768px) {
  .label {
    font-size: 5vw;
  }

  .value {
    font-size: 20vw;
  }

  .time-unit {
    width: 22vw;
    height: 22vw;
    margin: 0 1.5vw;
  }

  .time-text {
    font-size: 7vw;
  }

  .time-label {
    font-size: 1.5vw;
  }

  .countdown-row {
    flex-wrap: nowrap;
  }
}
</style>